import { useNoMemo } from '@/hooks';
import { Box } from '@mui/material';
import { useVirtualizer } from '@tanstack/react-virtual';
import { Children, forwardRef, useRef } from 'react';

const LISTBOX_PADDING = 8;

export const VirtualisedListbox = forwardRef(
  function VirtualisedListbox(props, ref) {
    const { children, styles, renderRow, ...other } = props;
    const itemData = Children.toArray(children);
    const itemCount = itemData.length;
    const itemSize = 40;
    const height = Math.min(10, itemCount) * itemSize + 2 * LISTBOX_PADDING;

    const scrollRef = useRef(null);
    const virtualizer = useVirtualizer({
      count: itemCount,
      getScrollElement: () => scrollRef.current,
      estimateSize: () => itemSize,
      overscan: 5,
    });
    const virtualItems = useNoMemo(() => virtualizer.getVirtualItems());

    return (
      <Box ref={ref}>
        <ul
          ref={scrollRef}
          {...other}
          style={{
            height,
            width: '100%',
            margin: 0,
            padding: 0,
            overflow: 'auto',
            position: 'relative',
            listStyle: 'none',
          }}
        >
          <li
            style={{ height: virtualizer.getTotalSize(), position: 'relative' }}
          >
            {virtualItems.map((virtualItem) =>
              renderRow({
                index: virtualItem.index,
                style: {
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: virtualItem.size,
                  transform: `translateY(${virtualItem.start}px)`,
                },
                data: { ...itemData, styles },
              }),
            )}
          </li>
        </ul>
      </Box>
    );
  },
);
